<script>
	const inputValidationMixin = require('mixins/input-validation-mixin.js');
	const stringUtilities = require('utilities/stringUtilities');
	const formValidationUtilities = require('utilities/formValidationUtilities');
	const patterns = formValidationUtilities.patterns;
	const messages = formValidationUtilities.messages;
	const errors = formValidationUtilities.errors;

	module.exports = {
		mixins: [inputValidationMixin],
		props: {
			debounceDelay: {
				default: 500
			},
			type: {
				default: 'text'
			},
			pattern: {
				default: null
			},
			value: {
				required: true
			},
			unsafe: {
				type: Boolean
			}
		},
		computed: {
			patternInternal() {
				let type = this.type;
				let pattern = this.pattern || patterns[type];

				return pattern;
			}
		},
		watch: {
			patternMessage: {
				handler(v) {
					let type = this.type;
					let pattern = this.pattern;
					if (!v && type === 'text' && !pattern) {
						this.patternMessage = messages[errors.EMPTY];
					}
				},
				immediate: true
			}
		},
		methods: {
			onKeyup(e) {
				if (this.touched && e && e.key !== 'Enter') {
					this.checkValidity();
				}
			},
			onChange(e) {
				this.checkValidity();
			},
			onInvalid() {
				if (!this.touched) {
					this.touched = true;
					this.checkValidity();
				}
			},
			onInput(inputVal) {
				if (this.unsafe) {
					this.$emit('input', stringUtilities.stripHTML(inputVal));
				} else {
					this.$emit('input', inputVal);
				}
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.input.validated-input {
		// Don't immediately show invalid on page load
		// only after user has used element
		&.touched:invalid {
			border-color: $c-red;
		}
	}
</style>
<template>
	<input
		class="validated-input input"
		:class="{
			touched: touched
		}"
		:value="value"
		:type="type"
		:pattern="patternInternal"
		@input="onInput($event.target.value)"
		@keyup="onKeyup"
		@change="onChange"
		@invalid="onInvalid"
		v-tooltip="message" />
</template>
